import './index.css'
import '../../../i18n'
import en1 from '../../../images/digitalWallet/en/1.png'
import en2 from '../../../images/digitalWallet/en/2.png'
import en3 from '../../../images/digitalWallet/en/3.png'
import en4 from '../../../images/digitalWallet/en/4.png'
import en5 from '../../../images/digitalWallet/en/5.png'
import en6 from '../../../images/digitalWallet/en/6.png'
import en7 from '../../../images/digitalWallet/en/7.png'
import en8 from '../../../images/digitalWallet/en/8.png'
import en9 from '../../../images/digitalWallet/en/9.png'
import en10 from '../../../images/digitalWallet/en/10.png'
import en11 from '../../../images/digitalWallet/en/11.png'
import en12 from '../../../images/digitalWallet/en/12.png'
import en13 from '../../../images/digitalWallet/en/13.png'


import ch1 from '../../../images/digitalWallet/ch/1.png'
import ch2 from '../../../images/digitalWallet/ch/2.png'
import ch3 from '../../../images/digitalWallet/ch/3.png'
import ch4 from '../../../images/digitalWallet/ch/4.png'
import ch5 from '../../../images/digitalWallet/ch/5.png'
import ch6 from '../../../images/digitalWallet/ch/6.png'
import ch7 from '../../../images/digitalWallet/ch/7.png'
import ch8 from '../../../images/digitalWallet/ch/8.png'
import ch9 from '../../../images/digitalWallet/ch/9.png'
import ch10 from '../../../images/digitalWallet/ch/10.png'
import ch11 from '../../../images/digitalWallet/ch/11.png'
import ch12 from '../../../images/digitalWallet/ch/12.png'
import ch13 from '../../../images/digitalWallet/ch/13.png'

import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {getQueryValue} from "../../../util";
import {Image} from "antd";


function Subscription() {
    const {t, i18n} = useTranslation()
    const [language, setLanguage] = useState('en')
    useEffect(() => {
        if (getQueryValue('language') === 'en') {
            i18n.changeLanguage('en')
            setLanguage('en')
        } else if (getQueryValue('language') === 'zh') {
            i18n.changeLanguage('zh')
            setLanguage('zh')
        } else {
            i18n.changeLanguage('zh')
            setLanguage('zh')
        }
    }, [language])
    return (
        <div className="App">
            <div className={'subscriptionTitle'}>
                <h3  style={{textAlign:'left',paddingLeft:'16px',width:'100%'}}>{t('digitalMetaTitle2')}</h3>
            </div>
            <div className='box'>
                <div className='imageBox'>
                    <div className='des'>
                        <p>{t('digitalMetaTitle2Des1')}</p>
                    </div>
                    <div className='box-image'>
                        <Image src={language === 'en' ? en1 : ch1} alt=''/>
                        <Image src={language === 'en' ? en2 : ch2} alt=''/>
                    </div>
                </div>
                <div className='imageBox'>
                    <div className='des'>
                        <p>{t('digitalMetaTitle2Des2')} </p>
                    </div>
                    <div className='box-image'>
                        <Image src={language === 'en' ? en3 : ch3} alt=''/>
                    </div>
                </div>
                <div className='imageBox'>
                    <div className='des'>
                        <p>{t('digitalMetaTitle2Des3')}</p>
                    </div>
                    <div className='box-image'>
                        <Image src={language === 'en' ? en4 : ch4} alt=''/>
                    </div>
                </div>

                <div className='imageBox'>
                    <div className='des'>
                        <p>{t('digitalMetaTitle2Des4')}</p>
                    </div>
                    <div className='box-image'>
                        <Image src={language === 'en' ? en5 : ch5} alt=''/>
                        <Image src={language === 'en' ? en6 : ch6} alt=''/>
                    </div>
                </div>

                {/*<div className='imageBox'>*/}
                {/*    <div className='des'>*/}
                {/*        <p>{t('digitalMetaTitle2Des5')}</p>*/}
                {/*    </div>*/}
                {/*    <div className='box-image'>*/}
                {/*        <Image src={language === 'en' ? en4 : ch4} alt=''/>*/}
                {/*    </div>*/}
                {/*</div>*/}
            </div>
            <div className={'subscriptionTitle'}>
                <h3  style={{textAlign:'left',paddingLeft:'16px',width:'100%'}}>{t('digitalMetaTitle3')}</h3>
            </div>


            <div className='box'>
                <div className='imageBox'>
                    <div className='des'>
                        <p>{t('digitalMetaTitle3Des1')}</p>
                    </div>
                    <div className='box-image'>
                        <Image src={language === 'en' ? en7 : ch7} alt=''/>
                    </div>
                </div>
                <div className='imageBox'>
                    <div className='des'>
                        <p>{t('digitalMetaTitle3Des2')} </p>
                    </div>
                    <div className='box-image'>
                        <Image src={language === 'en' ? en8 : ch8} alt=''/>
                    </div>
                </div>
                <div className='imageBox'>
                    <div className='des'>
                        <p>{t('digitalMetaTitle3Des3')}</p>
                    </div>
                    <div className='des'>
                        <p style={{fontWeight:'600'}}>{t('digitalMetaTitle3Des3MetaMask')} </p>
                    </div>
                    <div className='box-image'>
                        <Image src={language === 'en' ? en9 : ch9} alt=''/>
                        <Image src={language === 'en' ? en10 : ch10} alt=''/>
                    </div>
                    <div className='des'>
                        <p>{t('digitalMetaTitle3Des3MetaMaskNet')} </p>
                    </div>
                    <div className='des'>
                        <p  style={{fontWeight:'600'}}>{t('digitalMetaTitle3Des3Binance')} </p>
                    </div>
                    <div className='box-image'>
                        <Image src={language === 'en' ? en11 : ch11} alt=''/>
                        <Image src={language === 'en' ? en12 : ch12} alt=''/>
                        <Image src={language === 'en' ? en13 : ch13} alt=''/>
                    </div>
                    <div className='des'>
                        <p><span style={{color:'red'}}>{t('digitalMetaTitle3Des4')}</span>{t('digitalMetaTitle3Des5')}</p>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default Subscription;
